import React, { Component } from 'react';
import store from '../store/uploaddata-store';
import { Form, Input, Button, TextArea,Dimmer, Loader,Segment } from 'semantic-ui-react'
import eb from '../utils/EventBus';
import {observer} from 'mobx-react';
import Select from 'react-select';
import axios from 'axios';
import {properties} from '../environments';

const BLOCK_CHAIN_URL = properties.BLOCKCHAIN_URL;

class UploadData extends Component {

    state= {
        loading : false
    };

  constructor(props) {
    super(props);
    this.state={file: ''}
    this.handleUpload = this.handleUpload.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.init();
    eb.on('doc-created', () => this.props.history.push('/uploaddata'));
  }

  init()
  {
    store.selectedShUsers=null;
    store.selectedRvwUsers=null;
    store.selectedAppUsers=null;
    store.selectedGrp=null;
    store.getOrgEmail(); // to get userEmail and orgName to pass it to BC auth_user call
    store.loadShUsers();
    store.loadRvwUsers();
    store.loadAppUsers();
    store.loadGrps();
    store.selectedDoc = {};
  }


  upld=()=> {
    this.handleUpload();
  }

  onChange = (e) => {
    this.setState({ file: e.target.files[0] });
  }


  handleUpload = async(req, res) => {
        this.setState( {
            loading:true
        });

          console.log('handle upload');

          let fileId = Math.floor(new Date() / 1000)+Math.floor(Math.random()*100);
          //console.log({ fileId });
          const formData = new FormData();
          formData.append('file', this.state.file);

          // Get BC token
          const tokenData = await store.getBlockChainToken(store.username, store.orgname);;
          console.log(tokenData.token);


          // BC upload call
          axios.post(`${BLOCK_CHAIN_URL}/api/v1/upload_file/${fileId}`, formData, { headers: { 'Authorization': `Bearer ${tokenData.token}` } })
            .then((result) => {
              console.log(result);
              let fname=result.data.filename;
                let filesize = result.data.filesize;

            if ((result.data.success===true) && (result.data.status===200) && (result.data.respcode===250)) {
                // If doc already exists with the same name and content
                 alert('Document not uploaded as it already exists with the same name and content');
                this.setState({ loading: false});
                 return false;
            } else if(result.data.success===true && result.data.status===200 && result.data.respcode===251) {
                 // If the content of the new doc that is being uploaded exists in BC in another doc, then continue with upload and display a warning message
                  let fileName = result.data.fileName;
                  let ipfshash=result.data.ipfshash;
                  let mimetype=result.data.mimetype;

                  const upData = {fileName,ipfshash,mimetype, filesize};

                  axios.post(`${BLOCK_CHAIN_URL}/api/v1/force_upload_file/${fileId}`, upData, { headers: { 'Authorization': `Bearer ${tokenData.token}` } })
            .then((result) => {
                      // Insert into docmaster table
                      store.loading=false;
                      store.setDocId(fileId);
                      store.setDocName(fileName);
                      store.setDocSize(filesize);
                      store.creDoc();
                      eb.emit('toast', {
                        status: 'success',
                        text: 'Uploaded Successfully even though another document already exists with the same content'
                      })
                      this.init();
                      this.setState({ loading: false});
                   });

                      return true;

            } else if (result.data.success===true) {
                      // Insert into docmaster table
                      store.loading=false;
                      store.setDocId(fileId);
                      store.setDocName(fname);
                      store.setDocSize(filesize);
                      store.creDoc();
                      eb.emit('toast', {
                        status: 'success',
                        text: 'Uploaded Successfully'
                      })
                      this.init();
                this.setState({ loading: false});
            }
            });
    }


  render() {
    const { loading } = this.state;
    const doc = store.selectedDoc || {};

    return (

         <div className="buyer-invoice">
           <div className="title">
          <h4 align="left">Upload New Document</h4>
         </div>


        <Form>

           <form onSubmit={this.handleUpload}>
            <div className="mb-1">
              <Form.Field inline>
                <label>Select Document</label>
                <input onChange={this.onChange} type="file" className="w-100"/>
              </Form.Field>
            </div>
          </form>

           <Form.Field inline>
              <label>Description</label>
              <Input value={store.docdescr} onChange={(evt, { value }) => store.setDocDescr(value)}  className="w-100"/>
            </Form.Field>

            <Form.Field inline>
              <label>Tags</label>
              <Input value={store.tag} onChange={(evt, { value }) => store.setTag(value)}  className="w-100"/>
            </Form.Field>

            <Form.Field inline>
              <label>Share with user(s)</label>
              <Select isMulti={true}
                      value={store.selectedShUsers}
                      onChange={(selectedShOption) => store.setSelectedShUsers(selectedShOption)}
                      options={store.selectedShUsersOptions}
                />
            </Form.Field>

            <Form.Field inline>
              <label>Reviewer(s)</label>
               <Select isMulti={true}
                      value={store.selectedRvwUsers}
                      onChange={(selectedRvwOption) => store.setSelectedRvwUsers(selectedRvwOption)}
                      options={store.selectedRvwUsersOptions}
                />
            </Form.Field>

            <Form.Field inline>
              <label>Approver(s)</label>
               <Select isMulti={true}
                      value={store.selectedAppUsers}
                      onChange={(selectedAppOption) => store.setSelectedAppUsers(selectedAppOption)}
                      options={store.selectedAppUsersOptions}
                />
            </Form.Field>


            <Form.Field inline>
              <label>Comment</label>
              <TextArea input value={store.comments} onChange={(evt, { value }) => store.setComments(value)}/>
            </Form.Field>

            <Form.Field inline>
              <label>Attach/Link this document to an existing group</label>
              <Select  value={store.selectedGrp}
                            onChange={(selectedGrpOption) => store.setSelectedGrp(selectedGrpOption)}
                            options={store.selectedGrpOption}
               />
            </Form.Field>
<div align="center" className="or">
            <Form.Field inline>
              <label>Or</label>
            </Form.Field>
</div>

            <Form.Field inline>
              <label>Create a new group</label>
              <Input value={store.newgrpname} onChange={(evt, { value }) => store.setNewGrp(value)}  className="w-100" />
            </Form.Field>

          <div>
              <Button primary onClick={this.upld}  className="save" disabled={!this.state.file} >
                  {loading && (
                      <i class = "fa fa-spinner fa-spin"> </i>
                  )}
                  {loading && <span> Uploading</span>}
                  {!loading && <span> Upload</span>}
                  </Button>
          </div>

        </Form>

        <div className="footer">

        </div>
      </div>

    );
 }

}


export default observer(UploadData);

/*

    {store.loading && (
                  <Segment>
                    <Dimmer active inverted>
                      <Loader inverted>Loading</Loader>
                    </Dimmer>
                  </Segment>
    )}

    */





// WEBPACK FOOTER //
// ./src/containers/UploadData.js